<template>
  <div class="parent-child-select">
    <div class="parent-select">
      <BaseElSelect
        v-model="selectedParent"
        :disabled="disabled"
        clearable
        @change="onParentChange"
        @clear="onParentClear"
      >
        <BaseElSelectOption
          v-for="option in subFieldOptions"
          :key="option.parentValue"
          :label="option.parentValue"
          :value="option.parentValue"
        />
      </BaseElSelect>
    </div>
    <div class="child-select mt-2">
      <BaseElSelect
        v-model="selectedChild"
        :disabled="disabled || !selectedParent"
        clearable
        @change="onChildChange"
        @clear="onChildClear"
      >
        <BaseElSelectOption
          v-for="child in currentChildOptions"
          :key="child"
          :label="child"
          :value="child"
        />
      </BaseElSelect>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, computed, onMounted } from 'vue'
import { get } from 'lodash'

export default defineComponent({
  name: 'ParentChildSelect',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    subFieldOptions: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    parentPlaceholder: {
      type: String,
      default: '',
    },
    childPlaceholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'change'],
  setup (props, { emit }) {
    const selectedParent = ref('')
    const selectedChild = ref('')

    const currentChildOptions = computed(() => {
      if (!selectedParent.value) return []
      const parentOption = props.subFieldOptions.find(option => option.parentValue === selectedParent.value)
      return parentOption ? parentOption.childOptions || [] : []
    })

    const emitChange = () => {
      const value = {
        parentValue: selectedParent.value,
        childValue: selectedChild.value,
      }

      emit('input', value)
      emit('change', value)
    }

    const onParentChange = () => {
      selectedChild.value = ''
      emitChange()
    }
    const onParentClear = () => {
      selectedParent.value = ''
      selectedChild.value = ''
      emitChange()
    }

    const onChildChange = () => {
      emitChange()
    }

    const onChildClear = () => {
      selectedChild.value = ''
      emitChange()
    }

    onMounted(() => {
      if (props.value) {
        selectedParent.value = get(props.value, 'parentValue', '')
        selectedChild.value = get(props.value, 'childValue', '')
      }
    })

    return {
      selectedParent,
      selectedChild,
      currentChildOptions,
      onParentChange,
      onParentClear,
      onChildChange,
      onChildClear,
    }
  },
})
</script>

<style lang="postcss" scoped>
.parent-child-select {
  @apply w-full;
}

.parent-select,
.child-select {
  @apply w-full;
}
</style>
